import React, { Component } from 'react';

// case Section
class ContactSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: true
    }
  }
  collapse = () => {
    if (this.state.isOpen === false) {
      this.setState({
        isOpen: true
      })
    } else {
      this.setState({
        isOpen: false
      })
    }
  }
  render() {
    const { headerTitle } = this.props;
    const { email, fullName, phone } = this.props.caseOwner;
    return (
      <div className="case-menu__section">
        <h2 className="case-menu__section__header gdocs-responsive-text">{headerTitle}</h2>
        <span className="case-menu__section__bar"></span>
        <ul className={this.state.isOpen === true ? `case-menu__list gdocs-responsive-text` : 'case-menu__list gdocs-responsive-text hide'}>
          <li className="case-menu__list__item contact-section-medium-font horizontal-rules">{fullName}</li>
          {
            typeof phone !== 'undefined'
              ? <li className="case-menu__list__item case-menu__list__item-phone horizontal-rules">
                <span className="icon icon-phone fontsize24" aria-label='phone-number' role='img'></span>
                <span className="gdocs-valign-top">{typeof phone !== 'undefined' ? phone : ""}</span>
              </li>
              : ''
          }
          {
            typeof email !== 'undefined' && email !== ''
              ? <li className="case-menu__list__item case-menu__list__item-email">
                <span className="icon icon-message gdocs-valign-bottom fontsize24" aria-label='email-address' role='img'></span>
                <span className="valign-top">{email}</span>
              </li>
              : ''
          }
        </ul>
      </div>
    );
  }
}
ContactSection.defaultProps = {
  headerTitle: '',
  data: [],
  roleDetails: {}
}
export default ContactSection



// WEBPACK FOOTER //
// ./src/components/common/CaseMenu/ContactSection.js